<template>
  <div>
    <!-- el-tabs 多标签页 v-event.test='`_error(a,b)`' v-event:tab-click:@test -->
    <span v-once :x='$nextTick(v => Data.currentTab = "1")'></span>
    <el-tabs type="border-card" v-model='Data.currentTab' v-s.height='H - 74' tab-click='$trigger(Data.currentTab)'
      @tab-remove="(tab) => {
        editableTabs.splice(tab - 2);
        Data.currentTab = --tab + '';
      }">

      <el-tab-pane label="省级战队" name='1'>

        <el-row style="margin-bottom:10px;">
          <el-col :span="18" class='flex'>
            <el-input v-model="Data.inputText" placeholder="请输入战队名称" clearable size='small' style="max-width:380px;" />
            <el-button @click='enter(Data.inputText)' type="primary" icon='el-icon-search' size='small'
              style='margin-left:10px;'>搜索</el-button>
          </el-col>
          <el-col :span="6">
            <!-- <el-button
                remark="👆上面是自定义的,👇下面是固定的无需修改"
                @click="_confirm('确定要删除所选分类吗?').trigger('deleteFirstClass',{id:queryFirstClass_data.$selection.map(v=>v.id||'').join(',')}).queryFirstClass()"
                size='small'
                type="primary"
                style="float:right"
                icon=''>删除</el-button> -->
            <el-button v-if='addDepartment' @click="$form('addDepartment')" size='small' type="primary"
              style="float:right;margin-right:10px;" icon='el-icon-circle-plus'>添加省级战队</el-button>
            <el-button v-if='addUser' @click="$form('addMultiUsersAll'), tabledataAll = [], row = {}" size='small'
              type="primary" style="float:right" icon='el-icon-circle-plus'>批量添加学员
            </el-button>

            <!-- <el-button
                @click="$form('addAuth')"
                size='small'
                type="primary"
                style="float:right;margin-right:10px;"
                icon='el-icon-delete' >批量删除</el-button> -->
          </el-col>
        </el-row>

        <!-- section 包裹了两个组件: el-table 表格 + el-pagination分页 它们两个通常是不可分割的整体, 一块加上 -->
        <mytable :tree="{ children: 'children' }" :tableColums='tableColums' api='getDepartmentList::dtId'
          updateapi='updateDepartment' :height="H - 230">
          <!-- <el-input slot='dtName' slot-scope='{row}'
                size="medium" placeholder="请输入签约家数" style="width:70%;"
                v-model="row.value" clearable
            ></el-input> -->
        </mytable>

      </el-tab-pane>

      <el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.parent + ' - ' + item.title"
        :name="item.name" :lazy=true :closable=true>

        <el-row style="margin-bottom:10px;">

          <el-col :span="18" class='flex'>
            <el-input v-model="item.inputText" placeholder="请输入战队名称" clearable size='small' style="max-width:380px;" />

            <el-button @click='enter(item.inputText)' type="primary" icon='el-icon-search' size='small'
              style='margin-left:10px;'>搜索</el-button>
            <!--@click="item.name == 'updateSecondClass' ?  queryClassByParent() : queryThirdByParent() "-->
          </el-col>

          <el-col :span="6">
            <el-button v-if='addDepartment' @click="$form('addDepartment')" size='small' type="primary"
              style="float:right" icon='el-icon-circle-plus'>
              添加{{ item.title }}
            </el-button>
          </el-col>

        </el-row>

        <mytable :tableColums='tableColums' api='getDepartmentList::dtId' :data="'getDepartmentList' + (index + 2)"
          updateapi='updateDepartment' :height="H - 230">
        </mytable>

      </el-tab-pane>

    </el-tabs>

    <myform :viewobj='{
      addDepartment: ["新增战队", "el-icon-circle-plus"],
      updateDepartment: ["修改战队", "el-icon-edit-outline"],
      $succeed$: () => getDepartmentList({ $id$: Data.currentTab, dtLevel: +Data.currentTab })
    }' @opened="
  arguments.row = $this['$' + Data.currentTab] || { dtId: 0 };
arguments[0].title = '新增' + oPlus[Data.currentTab] + (Data.currentTab !== '1' ? ' | @' + arguments.row.dtName : '');
Myformdata.with({
  dtParentId: arguments.row.dtId,
  dtLevel: Data.currentTab * 1,
  dtPriority: $this['getDepartmentList' + (Data.currentTab === '1' ? '' : Data.currentTab) + '_data'].data.length + 1
});
">
      <hide slot='projectId' />
      <hide slot='dtParentId' />
      <hide slot='dtLevel' />
    </myform>

    <myform view.lookUsers='学员' id='FormTop' top='20px' @opened='arguments[0].title += " | @" + row.dtName'
      @close='$form("lookUsers", "hide")'>
      <el-button v-if='addUser' @click="$form('addMultiUsers'), tabledata = []" size='small' type="primary"
        style="float:right" icon='el-icon-circle-plus'>批量添加
      </el-button>
      <el-button v-if='addUser' @click="$form('addUser')" size='small' type="primary" style="float:right"
        icon='el-icon-circle-plus'>添加账号
      </el-button>
      <el-button v-if="deleteUser" @click="doMultiDelete" size='small' type="primary" style="float:right"
        icon='el-icon-delete'>批量删除
      </el-button>
      <mytable ref="getProjectUserListTable" :tableColums='tableColums_getProjectUserList'
        api='getProjectUserList::userId' xupdateapi='updateUser' :height="H - 165">
      </mytable>
    </myform>

    <myform :viewobj='{
      addUser: ["新增账号信息", "el-icon-circle-plus"],
      updateUser: ["修改账号信息", "el-icon-edit-outline"],
      $succeed$: getProjectUserList
    }' @close='$form("updateUser", "reset")' @confirm='myformUser'>
      <!-- 类型id -->
      <template v-slot:yutId="{ Myformdata }">
        <el-select v-model='Myformdata.yutId' clearable>
          <el-option v-for="item in getUserTypeList_data.data || []" :key="item.yutId" :label="item.yutName"
            :value="item.yutId">
          </el-option>
        </el-select>
      </template>
      <hide slot='userId' />
      <hide slot='postId' />
      <hide slot='roleListString' />
      <hide slot='dtId' />
      <hide slot='loginApp' />
      <hide slot='loginPc' />
    </myform>
    <myform view.addChatGroup="战队群#el-icon-check#保存" @opened='arguments[0].title += " | @" + row.dtName'
      @close='$form("addChatGroup", "hide")'>
      <hide slot='dtId' />
      <template v-slot:ownerId="{ Myformdata }">
        <el-select v-model='Myformdata.ownerId' clearable>
          <el-option v-for="item in getDepartmentManageList_data.data || []" :key="item.userId" :label="item.userName"
            :value="item.userId">
          </el-option>
        </el-select>
      </template>
    </myform>

    <myform view.addMultiUsers="批量导入学员" @opened='arguments[0].title += " | @" + row.dtName'
      @close='$form("addMultiUsers", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="upload" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="tabledata" v-if="(tabledata || '').length > 0" max-height="400">
        <el-table-column prop="name" label="用户名" width="120">
        </el-table-column>
        <el-table-column prop="yutName" label="用户类型" width="120">
        </el-table-column>
        <el-table-column prop="account" label="工号" width="80">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="status" fixed="left" label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '失败'" style="color:red;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusMsg" fixed="left" label="账号描述" width="140">
        </el-table-column>
        <el-table-column prop="targetJs" label="签约总家数" width="100">
        </el-table-column>
        <el-table-column prop="targetJe" label="签约总金额" width="100">
        </el-table-column>
        <el-table-column prop="targetSl" label="签约总数量" width="100">
        </el-table-column>
        <el-table-column prop="targetVisitor" label="每日走访目标" width="100">
        </el-table-column>
        <el-table-column prop="targetMoney" label="每日开单金额目标" width="100">
        </el-table-column>
      </el-table>
    </myform>
    <myform view.addMultiUsersAll="批量导入学员" @opened='arguments[0].title += " | @" + "所有战队网格"'
      @close='$form("addMultiUsersAll", "hide")'>
      <el-row>
        <el-col :span="4" style="min-width:100px;">
          <el-button type="primary" @click="toDownExcel">下载<i class="el-icon-download el-icon--right"></i></el-button>
        </el-col>
        <el-col :span="20">
          <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
            :on-change="onChangeContent">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
        <el-table-column prop="dtName" label="战队网格" width="120">
        </el-table-column>
        <el-table-column prop="name" label="用户名" width="120">
        </el-table-column>
        <el-table-column prop="yutName" label="用户类型" width="120">
        </el-table-column>
        <el-table-column prop="account" label="工号" width="80">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120">
        </el-table-column>
        <el-table-column prop="status" fixed="left" label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '失败'" style="color:red;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusMsg" fixed="left" label="账号描述" width="140">
        </el-table-column>
        <el-table-column prop="targetJs" label="签约总家数" width="100">
        </el-table-column>
        <el-table-column prop="targetJe" label="签约总金额" width="100">
        </el-table-column>
        <el-table-column prop="targetSl" label="签约总数量" width="100">
        </el-table-column>
        <el-table-column prop="targetVisitor" label="每日走访目标" width="100">
        </el-table-column>
        <el-table-column prop="targetMoney" label="每日开单金额目标" width="100">
        </el-table-column>
      </el-table>
    </myform>

    <el-dialog title="绑定 - 公司/楼宇/物业/楼园长" :visible.sync="BuildingVisible" width="50%" :before-close="handleClose">

      <el-card style="margin:15px">
        <div style="margin: 20px;text-align: center;color:##409EFF;">绑定楼园长</div>

        <div style="margin: 20px;">
          用户
        </div>
        <div style="margin: 20px;">
          <el-select v-model='form.userIds' clearable filterable multiple>
            <el-option v-for="item in getProjectUserLists_data.data || []" :key="item.userId" :label="item.userName"
              :value="item.userId">
            </el-option>
          </el-select>
        </div>
        <div style="margin: 20px;"
          v-if="getDepartmentBuildingByDt_data.data && getDepartmentBuildingByDt_data.data.length > 0">
          已经绑定过的用户
        </div>
        <div style="margin: 20px;">
          <!-- <el-select v-model='userId' clearable multiple>
            <el-option v-for="item in getDepartmentBuildingByDt_data.data || []" :key="item.userId"
              :label="item.userName" :value="item.userId">
            </el-option>
          </el-select> -->
          <mytable ref="getDepartmentBuildingByDtTable" :tableColums='tableColums_getDepartmentBuildingByDt'
            api='getDepartmentBuildingByDt' :height="300" xupdateapi='updateUser'>
          </mytable>
        </div>
        <div style="width: 100%;text-align: right;">
          <el-button type="primary" @click="addBuilding('4')">确定绑定楼园长</el-button>
        </div>
      </el-card>

      <el-card style="margin:15px">
        <div style="margin: 20px;text-align: center;color:##409EFF;">绑定公司</div>
        <div style="margin: 20px;">
          公司
        </div>
        <div style="margin: 20px;">
          <el-select v-model='form.customIds' clearable multiple filterable>
            <el-option v-for="item in getUserVisitorCompanyList_data.data || []" :key="item.customId"
              :label="item.yuvcName" :value="item.customId">
            </el-option>
          </el-select>
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorCompanyByDt_data.data && getUserVisitorCompanyByDt_data.data.length > 0">
          已经绑定过的公司
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorCompanyByDt_data.data && getUserVisitorCompanyByDt_data.data.length > 0">
          <el-table :data="getUserVisitorCompanyByDt_data.data" max-height="400">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column prop="dtName" label="战队">
            </el-table-column>
            <el-table-column prop="yuvcName" label="公司名称">
            </el-table-column>

            <el-table-column label="操作" width="140">
              <template slot-scope="scope">

                <el-button size="mini" type="text" @click="handleDelete(scope.row.yuvbuId, 2)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 100%;text-align: right;">
          <el-button type="primary" @click="addBuilding('1')">确定绑定公司</el-button>
        </div>
      </el-card>

      <el-card style="margin:15px">
        <div style="margin: 20px;text-align: center;color:##409EFF;">绑定楼宇</div>
        <div style="margin: 20px;">
          楼宇分类:
        </div>
        <div style="margin: 20px;">
          <el-select v-model='form.yuvbcId' clearable @change="getBuildingList">
            <el-option v-for="item in getUserVisitorBuildingClassList_data.data || []" :key="item.yuvbcId"
              :label="item.yuvbcName" :value="item.yuvbcId">
            </el-option>
          </el-select>
        </div>
        <div style="margin: 20px;">
          楼宇
        </div>
        <div style="margin: 20px;">
          <el-select v-model='form.yuvbIds' clearable multiple filterable>
            <el-option v-for="item in getUserVisitorBuildingList_data.data || []" :key="item.yuvbId"
              :label="item.yuvbName" :value="item.yuvbId">
            </el-option>
          </el-select>
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorBuildingByDt_data.data && getUserVisitorBuildingByDt_data.data.length > 0">
          已经绑定过的楼宇
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorBuildingByDt_data.data && getUserVisitorBuildingByDt_data.data.length > 0">

          <el-table :data="getUserVisitorBuildingByDt_data.data" max-height="400">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column prop="dtName" label="战队">
            </el-table-column>
            <el-table-column prop="yuvbName" label="楼宇名称">
            </el-table-column>
            <el-table-column prop="yuvbvName" label="楼宇类型">
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">

                <el-button size="mini" type="text" @click="handleDelete(scope.row.yuvbuId, 2)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 100%;text-align: right;">
          <el-button type="primary" @click="addBuilding('2')">确定绑定楼宇</el-button>
        </div>
      </el-card>

      <el-card style="margin:15px">
        <div style="margin: 20px;text-align: center;color:##409EFF;">绑定物业</div>
        <div style="margin: 20px;">
          物业
        </div>
        <div style="margin: 20px;">
          <el-select v-model='form.yuvpIds' clearable multiple filterable>
            <el-option v-for="item in getUserVisitorPropertyList_data.data || []" :key="item.yuvpId"
              :label="item.yuvpName" :value="item.yuvpId">
            </el-option>
          </el-select>
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorPropertyByDt_data.data && getUserVisitorPropertyByDt_data.data.length > 0">
          已经绑定过的物业
        </div>
        <div style="margin: 20px;"
          v-if="getUserVisitorPropertyByDt_data.data && getUserVisitorPropertyByDt_data.data.length > 0">
          <el-table :data="getUserVisitorPropertyByDt_data.data" max-height="400">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column prop="dtName" label="战队">
            </el-table-column>
            <el-table-column prop="yuvpName" label="物业名称">
            </el-table-column>

            <el-table-column label="操作" width="140">
              <template slot-scope="scope">

                <el-button size="mini" type="text" @click="handleDelete(scope.row.yuvbuId, 2)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 100%;text-align: right;">
          <el-button type="primary" @click="addBuilding('3')">确定绑定物业</el-button>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>

      </span>
    </el-dialog>


  </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
//import func from '../../../vue-temp/vue-editor-bridge';
/*
  样例说明：
  1）所有接口支持链式调用，如 addUser('正在添加..').queryUser("正在查询..")
*/
export default {
  data() {
    return {
      yuvbId: '',
      yuvpId: '',
      customId: '',
      userId: '',
      form: {
        userIds: '',
        dtId: '',
        yuvbcId: '',
        yuvbcName: '',
        yuvbName: '',
        yuvbIds: [],
        yuvpIds: [],
        customIds: [],
      },
      formCopy: {
        userIds: '',
        dtId: '',
        yuvbcId: '',
        yuvbcName: '',
        yuvbName: '',
        yuvbIds: [],
        yuvpIds: [],
        customIds: [],
      },
      BuildingVisible: false,
      dtId: null,
      theYutId: "",
      tabledata: [/* {
        name:"",     //用户名
        account:"", //工号
        phone:"",    //手机号
        status:"",   //是否成功还是失败
        statusMsg:"",  //描述
        targetJe:null,  //签约总金额
        targetJs:null,  //签约总家数
        targetMoney:null,  //每日开单总金额
        targetSl:null,   //签约总数量
        targetVisitor:null //每日走访目标
      } */],
      tabledataAll: [/* {
        name:"",     //用户名
        account:"", //工号
        phone:"",    //手机号
        status:"",   //是否成功还是失败
        statusMsg:"",  //描述
        targetJe:null,  //签约总金额
        targetJs:null,  //签约总家数
        targetMoney:null,  //每日开单总金额
        targetSl:null,   //签约总数量
        targetVisitor:null //每日走访目标
      } */],
      Userinfo: {},
      theDepartment: {},
      muldel1: false,
      muldel2: false,
      muldel3: false,
      oPlus: ['', '省级战队', '市级战队', '区级战队', '区域'],
      editableTabs: [],
      row: {},
      tableColums_getDepartmentBuildingByDt: {
        $selection: false,
        dtName: '战队名称',
        userName: '用户名称',
        $operation: [
          '操作', 200,

          this.deleteDepartmentBuilding && `@text: 删除#danger
                     @click: _confirm('确定要删除吗?')
                     .trigger('deleteDepartmentBuilding',{ydbId:$row.ydbId})
                     .trigger('getDepartmentBuildingByDt')
            `,
        ],
      },
      tableColums_getUserVisitorCompanyByDt: {
        $selection: false,
        dtName: '战队名称',
        yuvcName: '公司名称',
        $operation: [
          '操作', 200,

          this.deleteUserVisitorDtRelations && `@text: 删除#danger
                     @click: _confirm('确定要删除吗?')
                     .trigger('deleteUserVisitorDtRelations',{yuvbuId:$row.yuvbuId})
                     .trigger('getUserVisitorCompanyByDt')
            `,
        ],
      },
      tableColums_getUserVisitorBuildingByDt: {
        $selection: false,
        dtName: '战队名称',
        yuvbName: '楼宇名称',
        yuvbcName: '楼宇类型',
        $operation: [
          '操作', 200,

          this.deleteUserVisitorDtRelations && `@text: 删除#danger
                     @click: _confirm('确定要删除吗?')
                     .trigger('deleteUserVisitorDtRelations',{yuvbuId:$row.yuvbuId})
                     .trigger('getUserVisitorBuildingByDt')
            `,
        ],
      },
      tableColums_getUserVisitorPropertyByDt: {
        $selection: false,
        dtName: '战队名称',
        yuvpName: '物业名称',

        $operation: [
          '操作', 200,

          this.deleteUserVisitorDtRelations && `@text: 删除#danger
                     @click: _confirm('确定要删除吗?')
                     .trigger('deleteUserVisitorDtRelations',{yuvbuId:$row.yuvbuId})
                     .trigger('getUserVisitorPropertyByDt')
            `,
        ],
      },
      /* 在这里 动态渲染你的 tableColums表格列, 哪一列不需要, [!注释掉 或 删除掉!] 即可 ; 还可以在这里 [!增改!] 列 */
      tableColums: {
        $selection: false,

        dtName: ["战队名称"],

        chatGroup: this.addChatGroup && [
          '战队群', 200,
          `@text: 战队群
           @click:
              $form("addChatGroup", $this.row = $row);
              getDepartmentManageList({dtId:$row.dtId});
          `,
        ],

        dtLevel: ['战队等级', 100, '@v-if: 1:省级战队#warn, 2:市级战队#warn, 3:区级战队#warn, 4:区域#warn'],

        dtPriority: ["战队排序", 85],

        createtime: ["创建时间", 200],

        $operation: (this.updateDepartment || this.deleteDepartment || this.getDepartmentList) && [
          "操作", 250,

          this.updateDepartment && `@text: 编辑#warn
           @click: $form( 'updateDepartment', $row )
          `,

          this.deleteDepartment && `@text: 删除#danger
           @click: _confirm('确定要删除该战队吗?')
                  .trigger( 'deleteDepartment', {dtId:$row.dtId} )
                  .trigger( 'getDepartmentList', { $id$: Data.currentTab } )
          `,

          `@text: {{ oPlus[+Data.currentTab+1] ? '查看' + oPlus[+Data.currentTab+1] : '' }}#success
           @click:
              let find, index, title = oPlus[index = + Data.currentTab + 1 + ''];

              editableTabs.length === 0 || void null === ( find = editableTabs.find(v=>v.name === index) )
              ? editableTabs.push({ name: index, title: title, parent: $row.dtName })
              : ( find.title = title, find.parent = $row.dtName );

              $this['$'+index] = $row;
              getDepartmentList({ $id$: index, dtLevel: index * 1, dtParentId: $row.dtId })(v=>Data.currentTab = index);
          `,
          `@text: 人员#success
           @v-if: Data.currentTab == 4
           @click: $form( 'lookUsers', $this.row = $row ),getProjectUserList({dtId:$row.dtId,postId:5})
          `,
          `@text: 绑定#success
           @v-if: Data.currentTab == 4 || Data.currentTab == 3
           @click:getUserBuilding($row)
          `,
        ],

      },
      tableColums_getProjectUserList: {
        $selection: true,

        userName: '用户名',
        userAccount: '工号',
        userPhone: '手机号',
        yutName: '类型',
        createtime: '创建时间|sortable',
        userRemark: ["账号描述", 120],
        $operation: (this.updateUser || this.deleteUser) && [
          '操作', 200,
          this.updateUser && `@text: 编辑#success
           @click: $form("updateUser",$row)
          `,
          this.deleteUser && `@text: 删除#danger
           @click: _confirm('确定要删除该账号吗?')
                   .trigger('deleteUser',{userListString:$row.userId+""})
                   .trigger('getProjectUserList')
          `,

        ],

      },
    };
  },

  watch: {

    // "queryFirstClass_data.data": function(data){
    //   // data.forEach()
    //   // console.error(data,this);
    // },

    // 'Data.currentTab': function(tab){
    //   console.error(tab,111111111);
    // }
  },

  methods: {
    handleDelete(id) {
      this.deleteUserVisitorDtRelations({ yuvbuId: id }).result(res => {
        this.getDepartmentBuildingByDt({ dtId: this.form.dtId });
        this.getUserVisitorCompanyByDt({ dtId: this.form.dtId });
        this.getUserVisitorBuildingByDt({ dtId: this.form.dtId });
      });

    },
    handleClose() {
      console.log(this.form);
      this.BuildingVisible = false;
      this.yuvbcId = null;
      this.form = this.formCopy;
      this.yuvbId = '';
      this.yuvpId = '';
      this.customId = '';
      this.userId = '';
      // this.getProjectUserList({postId:5,pageSize:15});
    },
    async addBuilding(id) {
      return new Promise((resolve, reject) => {
        if (id == '1') {
          this.addUserVisitorDtRelationsCompany(this.form).result(res => {
            resolve(this.getUserVisitorCompanyByDt({ dtId: this.form.dtId }))
          });
        } else if (id == '2') {
          this.addUserVisitorDtRelationsBuilding(this.form).result(res => {
            this.getUserVisitorBuildingByDt({ dtId: this.form.dtId })
          });
        } else if (id == '4') {
          this.addDepartmentBuildingByUser(this.form).result(res => {
            this.getDepartmentBuildingByDt({ dtId: this.form.dtId });
          })
        } else {
          this.addUserVisitorDtRelationsProperty(this.form).result(res => {
            this.getUserVisitorPropertyByDt({ dtId: this.form.dtId });
          });
        }
      })
    },
    getBuildingList(e) {
      console.log(e);
      this.getUserVisitorBuildingList({ yuvbcId: e, yuvbType: 1 });
    },
    async getUserBuilding(row) {
      this.form.dtId = row.dtId;
      this.getProjectUserLists({ postId: 5, pageSize: 0 });
      const all = [this.getUserVisitorBuildingByDt({ dtId: row.dtId }), this.getUserVisitorCompanyByDt({ dtId: row.dtId }),
      this.getUserVisitorPropertyByDt({ dtId: row.dtId }), this.getDepartmentBuildingByDt({ dtId: row.dtId })
      ]
      return await Promise.all(all).then((values) => {
        console.log('11', values);
        this.BuildingVisible = true;
      })

    },


    async doMultiDelete() {
      const selection = Object.keys(this.$refs.getProjectUserListTable.$MyTableCache);
      if (selection.length === 0) return alertWarn('请选择您要删除的数据！');
      if (await this._confirm(`确定要删除这${selection.length}条吗?`)) {
        this.deleteUser({ userListString: selection.join() })
          .result(result => {
            if (result.data.result == "success") {
              alertSuccess(result.data.msg);
              this.getProjectUserList({ dtId: this.row.dtId, postId: 5 })
            } else {
              alertError(result.data.msg);
            }
          })
      };
    },
    toDownExcel() {
      myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/user.xlsx", "用户.xlsx");
    },
    enter(input = '') {
      const dtLevel = this.Data.currentTab * 1;
      this.getDepartmentList({ $id$: dtLevel, dtLevel, dtName: input });
    },
    myformUser(submit, Myformdata) {
      Myformdata.dtId = this.row.dtId;
      Myformdata.postId = 5;
      Myformdata.loginApp = 1;
      Myformdata.loginPc = 2;
      submit();
    },
    async onChangeContent(files, fileList) {
      const table = await this.doupload(files.raw);
      this.tabledata = table.data.data.data;
      this.tabledataAll = table.data.data.data;
      this.getProjectUserList();
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();  //清空文件
      }
      if (this.$refs.uploadAll) {
        this.$refs.uploadAll.clearFiles();  //清空文件
      }
    },
    doupload: async function (file) {
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      if (this.row && this.row.dtId) {
        param.append("dtId", this.row.dtId);
      }
      const loading = $Loading();
      const responseData = await myhttp.postFileUsers("/opportunity/auth-file/upload", param);
      loading.close();
      if (responseData.data.result == "success") {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
      } else {
        this.$message({
          type: "error",
          message: "上传失败!"
        });
      }
      return responseData
    },
    // yutChange(e){
    //   this.theYutId=e;
    //   this.getProjectUserList({yutId:this.theYutId});
    // },
  },

  created() {
    /* 在这里调用初始化接口 或者 执行你自己的数据存储和逻辑 */
    // this.$1 = { authType: 0, authId: 0, authParentId: 0, authName: '' };
    console.log(this.Data);
    this.Userinfo = $Parse(localStorage.getItem("$Userinfo"));
    this.theDepartment = this.Userinfo.department;
    // this.getDepartmentList({ $id$: 3, dtLevel: this.theDepartment.dtLevel,dtParentId:this.theDepartment.dtParentId });
    this.getDepartmentList({ $id$: 1, dtLevel: 1 });
    this.getUserTypeList({ pageSize: 0 });
    this.getUserVisitorBuildingClassList()
    this.getUserVisitorPropertyList({ yuvpType: 1, pageSize: 0 })
    this.getUserVisitorCompanyList({ yuvcType: 1, pageSize: 0 })
    this.getUserVisitorBuildingList({ yuvbType: 1, pageSize: 0 })
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/User/DepartmentManage.vue